import {
    GET_ADMINS,
    GET_ADMINS_SUCCESS,
    GET_ADMINS_FAILURE,
    UPDATE_ADMIN_STATUS,
    UPDATE_ADMIN_STATUS_SUCCESS,
    UPDATE_ADMIN_STATUS_FAILURE,
    DELETE_ADMIN,
    DELETE_ADMIN_SUCCESS,
    DELETE_ADMIN_FAILURE,
    ADD_ADMIN,
    ADD_ADMIN_SUCCESS,
    ADD_ADMIN_FAILURE,
    EDIT_ADMIN,
    EDIT_ADMIN_SUCCESS,
    EDIT_ADMIN_FAILURE,
    RESET_PASSWORD_ADMIN,
    RESET_PASSWORD_ADMIN_SUCCESS,
    RESET_PASSWORD_ADMIN_FAILURE,
    GET_MODULES,
    GET_MODULES_SUCCESS,
    GET_MODULES_FAILURE
} from "../Constants";

export const GetAdmins = (payload) => ({
    type: GET_ADMINS,
    payload
});

export const GetAdminSuccess = (payload) => ({
    type: GET_ADMINS_SUCCESS,
    payload
});

export const GetAdminsFailure = (payload) => ({
    type: GET_ADMINS_FAILURE,
    payload
});

export const UpdateAdminsStatus = (payload) => ({
    type: UPDATE_ADMIN_STATUS,
    payload
});

export const UpdateAdminStatusSuccess = (payload) => ({
    type: UPDATE_ADMIN_STATUS_SUCCESS,
    payload
});

export const UpdateAdminStatusFailure = (payload) => ({
    type: UPDATE_ADMIN_STATUS_FAILURE,
    payload
});

export const DeleteAdmin = (payload) => ({
    type: DELETE_ADMIN,
    payload
});

export const DeleteAdminSuccess = (payload) => ({
    type: DELETE_ADMIN_SUCCESS,
    payload
});

export const DeleteAdminFailure = (payload) => ({
    type: DELETE_ADMIN_FAILURE,
    payload
});

export const AddAdmin = (payload) => ({
    type: ADD_ADMIN,
    payload
});

export const AddAdminSuccess = (payload) => ({
    type: ADD_ADMIN_SUCCESS,
    payload
});

export const AddAdminFailure = (payload) => ({
    type: ADD_ADMIN_FAILURE,
    payload
});

export const EditAdmin = (payload) => ({
    type: EDIT_ADMIN,
    payload
});

export const EditAdminSuccess = (payload) => ({
    type: EDIT_ADMIN_SUCCESS,
    payload
});

export const EditAdminFailure = (payload) => ({
    type: EDIT_ADMIN_FAILURE,
    payload
});

export const ResetPasswordAdmin = (payload) => ({
    type: RESET_PASSWORD_ADMIN,
    payload
});

export const ResetPasswordAdminSuccess = (payload) => ({
    type: RESET_PASSWORD_ADMIN_SUCCESS,
    payload
});

export const ResetPasswordAdminFailure = (payload) => ({
    type: RESET_PASSWORD_ADMIN_FAILURE,
    payload
});

export const GetModules = (payload) => ({
    type: GET_MODULES,
    payload
});

export const GetModulesSuccess = (payload) => ({
    type: GET_MODULES_SUCCESS,
    payload
});

export const GetModulesFailure = (payload) => ({
    type: GET_MODULES_FAILURE,
    payload
});
